import React, { useEffect } from "react";
import "./styles/global.css";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";
import Hero from "./components/Hero";
import Collection from "./components/Collection";
import WhyUs from "./components/WhyUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CustomOrder from "./components/CustomOrder";
import Deals from "./components/Deals";
import CustomOrderFloat from "./components/CustomOrderFloat";
import ReturnPolicy from "./pages/ReturnPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import Admin from "./pages/Admin";
import SizeGuide from "./pages/SizeGuide";
import rings from "./data/rings";
import pendants from "./data/pendants";

function getPage() {
  const path = window.location.pathname;
  if (path === "/return-policy") return { type: "return-policy" };
  if (path === "/privacy-policy") return { type: "privacy-policy" };
  if (path === "/terms-and-conditions") return { type: "terms-and-conditions" };
  if (path === "/checkout") return { type: "checkout" };
  if (path === "/payment-success") return { type: "payment-success" };
  if (path === "/payment-failed") return { type: "payment-failed" };
  if (path.startsWith("/admin")) return { type: "admin" };
  if (path === "/size-guide") return { type: "size-guide" };
  if (path.startsWith("/product/")) {
    const id = path.replace("/product/", "");
    return { type: "product", productId: id };
  }
  return { type: "home" };
}

function AppContent() {
  const { type, productId } = getPage();
  const getProduct = (id) => {
    try {
      const saved = localStorage.getItem("rg_products");
      if (saved) {
        const all = JSON.parse(saved);
        return all.find(p => p.id === id) || null;
      }
    } catch {}
    return [...rings, ...pendants].find(p => p.id === id) || null;
  };
  const product = productId ? getProduct(productId) : null;
  const productLoading = false;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        document.body.style.display = "none";
        // eslint-disable-next-line no-unused-expressions
        document.body.offsetHeight;
        document.body.style.display = "";
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  return (
    <>
      <Navbar />
      <CartDrawer />
      {type === "return-policy" && <ReturnPolicy />}
      {type === "privacy-policy" && <PrivacyPolicy />}
      {type === "terms-and-conditions" && <TermsAndConditions />}
      {type === "checkout" && <Checkout />}
      {type === "payment-success" && <PaymentSuccess />}
      {type === "payment-failed" && <PaymentFailed />}
      {type === "admin" && <Admin />}
      {type === "size-guide" && <SizeGuide />}
      {type === "product" && productLoading && <div style={{padding:"200px 5%",textAlign:"center",color:"#7a6e68"}}>Loading...</div>}
      {type === "product" && !productLoading && product && <ProductDetail product={product} />}
      {type === "product" && !productLoading && !product && (
        <div style={{ padding: "200px 5%", textAlign: "center" }}>
          <h2>Product not found</h2>
          <button onClick={() => window.location.href = "/"}>Back to Home</button>
        </div>
      )}
      {type === "home" && (
        <>
          <Hero />
          <Collection />
      <Deals />
          <WhyUs />
          <Contact />
          <CustomOrder />
      <Footer />
      <CustomOrderFloat />
        </>
      )}
    </>
  );
}

export default function App() {
  return (
    <CartProvider>
      <AppContent />
    </CartProvider>
  );
}